import { Link, useHistory } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { createUser, getSchools } from '../../utils/functions';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import React from 'react';

function UserNew() {
    const history = useHistory();

    const roleOptions = [
        {
            key: 'admin',
            name: 'Admin',
        },
        {
            key: 'school-admin',
            name: 'School Admin',
        },
        {
            key: 'principal',
            name: 'Principal',
        },
    ];

    const dashboardOptions = [
        {
            key: 'dashboard',
            name: 'Dashboard',
        },
        {
            key: 'csip',
            name: 'CSIP',
        },
    ];

    const [user, setUser] = useState({
        role: roleOptions[0].key,
        permissions: [],
    });
    const [updateStatus, setUpdateStatus] = useState();
    const [schools, setSchools] = useState([]);
    useEffect(() => {
        const getAndSetSchools = async () => {
            const schoolList = await getSchools({
                select: '_id|name',
            });
            setSchools(schoolList.items);
        };

        getAndSetSchools();
    }, []);

    const onChangeValue = (value, key, index = null) => {
        console.log(value, key, index);
        const tempFormParams = Object.assign({}, user);
        if (index !== null) {
            if (!tempFormParams[key]) {
                tempFormParams[key] = [];
            }
            tempFormParams[key][index] = value;
        } else {
            tempFormParams[key] = value;
        }

        if (key === 'role' && (value === 'admin' || value === 'school-admin')) {
            delete tempFormParams['school'];
        }

        setUser(tempFormParams);
    };

    const onChangePermission = (checked, key) => {
        const tempFormParams = Object.assign({}, user);
        if (checked) {
            tempFormParams.permissions.push(key);
        } else {
            const index = tempFormParams.permissions.indexOf(key);
            if (index > -1) {
                // only splice array when item is found
                tempFormParams.permissions.splice(index, 1); // 2nd parameter means remove one item only
            }
        }

        setUser(tempFormParams);
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        if (user.role === 'principal' && !user.school) {
            user.school = schools[0]._id;
        }
        const response = await createUser(user);

        if (response.status) {
            setUpdateStatus({
                class: 'alert error',
                text: 'Error occurred while updating School Goal',
            });
        } else {
            history.push(`/users`);
        }

        setTimeout(() => {
            setUpdateStatus();
        }, 4000);
    };

    return (
        <>
            <Header title={`User Management - ${user?.username || 'New'}`} />

            <main className={'edit-container container'}>
                <div className={'edit-form-info'}>
                    <h3>
                        <Link to={'/'}>Dashboard</Link>
                    </h3>
                    <h3>
                        <Link to={'/CSIP'}>Schools</Link>
                    </h3>
                </div>
                <div className={'edit-form-info'}>
                    <h3>
                        <Link to={'/'}>Dashboard</Link>
                    </h3>
                    <h3>
                        <Link to={'/users'}>Users</Link>
                    </h3>
                    <h3>User - {user?.username || 'New'}</h3>
                    {updateStatus?.class && <h4 className={updateStatus.class}>{updateStatus.text}</h4>}
                </div>
                <form
                    className={'edit-form'}
                    onSubmit={(e) => {
                        onSubmit(e);
                    }}
                >
                    <div className={'flex-2 form-section'}>
                        <div className={'flex-column'}>
                            <h4 className={'label'}>Username:</h4>
                            <input
                                type={'text'}
                                value={user?.username || ''}
                                onChange={(e) => onChangeValue(e.target.value, 'username')}
                                required={true}
                            />
                        </div>
                        <div className={'flex-column'}>
                            <h4 className={'label'}>Email:</h4>
                            <input
                                type={'text'}
                                value={user?.email || ''}
                                onChange={(e) => onChangeValue(e.target.value, 'email')}
                                required={true}
                            />
                        </div>
                    </div>

                    <div className={'flex-2 form-section'}>
                        <div className={'flex-column'}>
                            <h4 className={'label'}>Password:</h4>
                            <input
                                type={'password'}
                                value={user?.password || ''}
                                onChange={(e) => onChangeValue(e.target.value, 'password')}
                                required={true}
                            />
                        </div>
                    </div>

                    <div className={'flex-2 form-section'}>
                        <div className={'flex-column'}>
                            <h4 className={'label'}>First Name</h4>
                            <input
                                type={'text'}
                                value={user?.first_name || ''}
                                onChange={(e) => onChangeValue(e.target.value, 'first_name')}
                                required={true}
                            />
                        </div>
                        <div className={'flex-column'}>
                            <h4 className={'label'}>Last Name:</h4>
                            <input
                                type={'text'}
                                value={user?.last_name || ''}
                                onChange={(e) => onChangeValue(e.target.value, 'last_name')}
                                required={true}
                            />
                        </div>
                    </div>

                    <div className={'flex-2 form-section'}>
                        <div className={'flex-column'}>
                            <h4 className={'label'}>Role:</h4>
                            <select
                                value={user?.role || roleOptions[0].key}
                                onChange={(e) => onChangeValue(e.target.value, 'role')}
                            >
                                {roleOptions.map((role, index) => (
                                    <option key={index} value={role.key}>
                                        {role.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        {user?.role === 'principal' && (
                            <div className={'flex-column'}>
                                <h4 className={'label'}>School:</h4>
                                <select
                                    value={user?.school || ''}
                                    onChange={(e) => onChangeValue(e.target.value, 'school')}
                                >
                                    {schools.map((school, index) => (
                                        <option key={index} value={school._id}>
                                            {school.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )}
                        {(user?.role === 'principal' || user?.role === 'school-admin') && (
                            <div className={'flex-column'}>
                                <h4 className={'label'}>School:</h4>
                                {dashboardOptions.map((opt, index) => (
                                    <div>
                                        <label>{opt.name}</label>
                                        <input
                                            type="checkbox"
                                            checked={user.permissions.includes(opt.key)}
                                            key={index}
                                            onChange={(e) => onChangePermission(e.target.checked, opt.key)}
                                        />
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    <div className={'form-section'}>
                        <button type={'submit'}>Save</button>
                    </div>
                </form>
            </main>
            <Footer />
        </>
    );
}

export default UserNew;
